import { render, staticRenderFns } from "./SubjectHistoryForms.vue?vue&type=template&id=7f439886&scoped=true&"
import script from "./SubjectHistoryForms.vue?vue&type=script&lang=js&"
export * from "./SubjectHistoryForms.vue?vue&type=script&lang=js&"
import style0 from "./SubjectHistoryForms.vue?vue&type=style&index=0&id=7f439886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f439886",
  null
  
)

export default component.exports